<template>
  <form-filtered-multiselect
    :value="storedCustomers"
    :options="customerOptions"
    :placeholder="placeholder"
    :limit-height="limitHeight"
    :hide-selected="hideSelected"
    :disabled="disabled"
    track-by="value"
    label="label"
    @input="onCustomersSelected" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    limitHeight: {
      type: Boolean,
      default: false
    },
    selectedKeys: {
      default: () => {
        return []
      }
    },
    placeholder: {
      default: 'Please select Customers'
    },
    hideSelected: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: [],
      storedCustomers: []
    }
  },
  computed: {
    ...mapGetters('customer', ['customerOptions'])
  },
  watch: {
    selectedKeys: function (newVal) {
      this.storedCustomers = newVal
    }
  },
  created () {
    this.storedCustomers = this.selectedKeys
  },
  methods: {
    onCustomersSelected (customers) {
      this.$emit('valuesSelected', customers)
    }
  }
}
</script>

<style>

</style>
